var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333252 7.0039C0.333252 3.32421 3.32553 0.333374 6.99992 0.333374C10.6743 0.333374 13.6666 3.32421 13.6666 7.0039C13.6666 10.6759 10.6743 13.6667 6.99992 13.6667C3.32553 13.6667 0.333252 10.6759 0.333252 7.0039ZM9.44522 7.67861C9.51601 7.60786 9.6061 7.49851 9.6254 7.47279C9.72836 7.33772 9.77984 7.17049 9.77984 7.0039C9.77984 6.81673 9.72193 6.64307 9.61253 6.50157C9.60356 6.49261 9.58601 6.4735 9.56312 6.44859C9.52032 6.402 9.45888 6.33513 9.40018 6.27645C8.87251 5.71044 7.49541 4.78425 6.77469 4.50125C6.6653 4.45687 6.38859 4.35975 6.24059 4.35331C6.09902 4.35331 5.96388 4.38547 5.83518 4.44979C5.67431 4.53984 5.54561 4.68134 5.47482 4.84857C5.42978 4.96434 5.35899 5.31167 5.35899 5.3181C5.28821 5.69758 5.2496 6.31504 5.2496 6.99682C5.2496 7.64709 5.28821 8.23818 5.34612 8.6241C5.34771 8.62569 5.35325 8.65329 5.36185 8.69616C5.38799 8.82652 5.44246 9.09808 5.50056 9.2094C5.64213 9.47954 5.91884 9.64677 6.21485 9.64677H6.24059C6.43364 9.64034 6.83904 9.47311 6.83904 9.46668C7.52115 9.18367 8.86607 8.3025 9.40661 7.7172L9.44522 7.67861Z",
    fill: "#081D3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayVideo);
export default __webpack_public_path__ + "static/media/PlayVideo.17851428e133c795b29af63d562a4b96.svg";
export { ForwardRef as ReactComponent };